<script>
import LoginWindowFooter from "./login-window-footer.vue";
import LoginBanner from "./login-banner.vue";
import LoginContainer from "./login-container.vue";
import LoginFooterIcons from "./login-footer-icons.vue";
import LoginForm from "./login-form.vue";
import LoginSubmitButton from "./login-submit-button.vue";
import LoginWindow from "./login-window.vue";
import LoginEmailField from "./login-email-field.vue";
import LoginPasswordField from "./login-password-field.vue";
import Loading from "../common/loading.vue";
import LoginStringField from "./login-string-field.vue";

export default {
    name: "totp",
    components: {
        LoginStringField,
        Loading,
        LoginPasswordField,
        LoginEmailField,
        LoginWindow,
        LoginSubmitButton,
        LoginForm,
        LoginFooterIcons,
        LoginContainer,
        LoginBanner,
        LoginWindowFooter
    },
    props: {
        loginUrl: String,
        versionText: String,
        csrfToken: String,
        errored: String
    },
    data() {
        return {
            valid: false,
            loading: false,
        }
    },
    provide() {
        return {
            appKey: this.appKey,
        }
    },
    computed: {
        translations() {
            return {
                login: Lang.langGet('Confirm code'),
                subTitle: Lang.langGet("To continue, open up your Authenticator app and issue your 2FA code or use one of your Recovery Codes"),
                title: Lang.langGet("Two Factor Authentication is required"),
                code: Lang.langGet('Code'),
                codeWrong: Lang.langGet("Code is wrong")
            }
        },
        hasErrors() {
            return this.errored === '1';
        }
    },
    methods: {
        handleSubmit() {
            this.loading = true;
        },
        handleValidity(_prop, value) {
            this.valid = value;
        }
    }
}
</script>

<template>
    <login-container>
        <loading :loading="loading"/>
        <login-window>
            <login-banner
                :title="translations.title"
                :subTitle="translations.subTitle"
            />

            <div v-if="hasErrors" class="login-error mb-2">{{translations.codeWrong}}</div>

            <login-form :url="loginUrl">
                <input type="hidden" name="_token" :value="csrfToken" autocomplete="off" />
                <login-string-field autofocus @valid="handleValidity" property="2fa_code" :label="translations.code" placeholder="123456" :exactLength="6" />
                <login-submit-button @click="handleSubmit" :disabled="!valid">
                    {{ translations.login }}
                </login-submit-button>
            </login-form>

            <login-window-footer :versionText="versionText" />
        </login-window>
        <login-footer-icons url="https://easescreen.com/"/>
    </login-container>
</template>

<style>
    .login-error {
        color: #ff5252;
    }
</style>
